import { FormStore, GlobalStore } from "@roc/feature-app-core";

import { action, makeObservable } from 'mobx';


const propertyForm = {
  fields: {
    propertyId: {
      value: null,
      error: null,
      rule: '',
    },
    mlsNumber: {
      value: null,
      error: null,
      rule: ''
    },
    proximity: {
      value: null,
      error: null,
      rule: ''
    },
    originalListDate: {
      value: '',
      error: null,
      rule: ''
    },
    originalListPrice: {
      value: '',
      error: null,
      rule: ''
    },
    domTrend: {
      value: '',
      error: null,
      rule: ''
    },
    propertyType: {
      value: '',
      error: null,
      rule: ''
    },
    saleType: {
      value: '',
      error: null,
      rule: ''
    },
    lotSize: {
      value: '',
      error: null,
      rule: ''
    },
    yearBuilt: {
      value: '',
      error: null,
      rule: ''
    },
    priceRent: {
      value: '',
      error: null,
      rule: ''
    },
    saleDate: {
      value: '',
      error: null,
      rule: ''
    },
    rooms: {
      value: '',
      error: null,
      rule: ''
    },
    bedrooms: {
      value: '',
      error: null,
      rule: ''
    },
    baths: {
      value: '',
      error: null,
      rule: ''
    },
    halfBaths: {
      value: '',
      error: null,
      rule: ''
    },
    area: {
      value: '',
      error: null,
      rule: ''
    },
    pricePerSqFt: {
      value: '',
      error: null,
      rule: ''
    },
    taxes: {
      value: '',
      error: null,
      rule: ''
    },
    parkingType: {
      value: '',
      error: null,
      rule: ''
    },
    amenities: {
      value: '',
      error: null,
      rule: ''
    },
    hasPool: {
      value: '',
      error: null,
      rule: ''
    },
    bestComparable: {
      value: null,
      error: null,
      rule: '',
    },
    weightAdjustment: {
      value: null,
      error: null,
      rule: '',
    },
    noOfUnits: {
      value: null,
      error: null,
      rule: '',
    },
    view: {
      value: '',
      error: null,
      rule: '',
    },
    comparability: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PropertyCompFormStore extends FormStore {
  public globalStore: GlobalStore;

  constructor(globalStore: GlobalStore) {
    super({ ...propertyForm }, globalStore);

    makeObservable(this, {
    });
  }



}